import {
  composeValidation,
  maximumCharacterLimit,
  stringEmpty,
  validateObject,
  ValidationFunc,
} from "validation/validation";

export type AboutYou = {
  firstName: string;
  lastName: string;
  email: string;
  confirmEmail: string;
  phoneCode: string;
  phoneNumber: string;
};

export const defaultAboutYou = (): AboutYou => {
  return {
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    phoneCode: "44",
    phoneNumber: "",
  };
};

const nameAllowedSymbolsValidation = (name: string) =>
  /(?!.*\s{2})(?!-*\s)^[a-z'-\s]*$/i.test(name)
    ? []
    : [`Please enter only alphabets, hyphens and spaces`];

export const firstnameValidation = composeValidation(
  stringEmpty("Please enter your first name"),
  nameAllowedSymbolsValidation,
  maximumCharacterLimit(255, "Maximum 255 characters")
);

export const lastnameValidation = composeValidation(
  stringEmpty("Please enter your last name"),
  nameAllowedSymbolsValidation,
  maximumCharacterLimit(255, "Maximum 255 characters")
);

export const emailValidation = (email: string) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )
    ? []
    : [`Please enter a valid email address`];

export const phoneNumberValidation = (phoneNumber: string) =>
  /^0?7\d{9}$/gm.test(phoneNumber)
    ? []
    : [
        `Please enter a UK mobile number starting 7XXXXXXXXX or 07XXXXXXXXX without any spaces`,
      ];
const verifyConfirmEmail = (email: string, confirmEmail: string) =>
  email && confirmEmail && email === confirmEmail
    ? []
    : [`This does not match the email address above`];

export const validateAboutYouBasic = validateObject<AboutYou>({
  firstName: firstnameValidation,
  lastName: lastnameValidation,
  email: emailValidation,
  phoneNumber: phoneNumberValidation,
});

export const validateConfirmEmailAboutYou: ValidationFunc<AboutYou> = ({
  email,
  confirmEmail,
}: AboutYou) => verifyConfirmEmail(email, confirmEmail);

export const validateAboutYou = composeValidation(
  validateAboutYouBasic,
  validateConfirmEmailAboutYou
);
